import { getIconProps, type IconProps } from '#types'

/**
 * Pencil icon — pure pencil, no surrounding container.
 *
 * Used for "write" / "draft" actions where the affordance is the act of
 * writing rather than editing an existing record. For "edit a document"
 * use {@link EditIcon} instead (pencil + open box).
 */
export function PencilIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M4.28047 18.5483C4.14621 19.2434 4.75695 19.8541 5.45206 19.7198L7.96827 19.2335C8.55632 19.1199 9.09689 18.8329 9.52039 18.4093L19.1861 8.74361C19.4442 8.48558 19.6488 8.17926 19.7885 7.84212C19.9281 7.50499 20 7.14365 20 6.77874C20 6.41383 19.9281 6.0525 19.7885 5.71536C19.6488 5.37823 19.4442 5.07191 19.1861 4.81388C18.9281 4.55585 18.6218 4.35116 18.2846 4.21152C17.9475 4.07187 17.5862 4 17.2213 4C16.8563 4 16.495 4.07187 16.1579 4.21152C15.8207 4.35116 15.5144 4.55585 15.2564 4.81388L5.59076 14.4795C5.16719 14.9031 4.88012 15.4437 4.76652 16.0319L4.28047 18.5483Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2734 5.79626C14.8919 7.65163 16.3478 9.10754 18.2032 9.726"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
